import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { EventAttendanceStatus } from '@modules/section/models/attendance.model';
import { EventModel, EventStates } from '@modules/section/models/event.model';
import { TranslateService } from '@ngx-translate/core';
import { formatDistanceToNowStrict } from 'date-fns';
import { de, enUS } from 'date-fns/locale';
import { interval, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'mb-event-ribbon-card',
  templateUrl: './event-ribbon-card.component.html',
  styleUrls: ['./event-ribbon-card.component.scss'],
})
export class EventRibbonCardComponent implements OnChanges, OnDestroy {
  public attendanceIcons: any = {
    representative: 'representative',
    has_substitute: 'representative',
    pending: 'invited',
    open: 'invited',
    confirmed: 'accepted',
    canceled: 'declined',
    declined: 'declined',
  };

  // used thumbor path

  @Input() event!: EventModel;

  // displayed counter maxEvent / countEvent
  @Input()
  index!: number;
  @Input()
  total!: number;

  public distance?: string;
  public attendanceIcon!: string;
  public attendance_status = EventAttendanceStatus;
  public eventStates = EventStates;

  private destroy$ = new Subject<boolean>();

  constructor(private translateService: TranslateService, private cdr: ChangeDetectorRef) {}

  ngOnChanges() {
    if (!this.event) {
      return;
    }

    interval(1000)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        if (!this.event || this.event.state !== EventStates.UPCOMING) {
          this.destroy$.next(true);
          return;
        }

        this.distance = formatDistanceToNowStrict(this.event.startDate, {
          addSuffix: true,
          locale: this.translateService.currentLang === 'de-DE' ? de : enUS, // TODO: integrate this into app service so we can use this across the app
        });
        this.cdr.detectChanges();
      });
  }

  public isExternalUrl() {
    return this.event.urlSlug?.startsWith('https://');
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
